module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "userNameChangePanel"
    }
  }, [_c('h1', [_vm._v("ユーザ名の変更")]), _vm._v(" "), _c('label', {
    staticClass: "cate2"
  }, [_vm._v("新しいユーザ名:\n    "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.new_user_name),
      expression: "new_user_name"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.new_user_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.new_user_name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "square_btn",
    on: {
      "click": _vm.changeUserNameLocal
    }
  }, [_vm._v("ユーザ名を変更")])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-676ad11c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-676ad11c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UserInfo/UserNameChangePanel.vue
// module id = 729
// module chunks = 0